module.exports = __webpack_public_path__ + "static/fasie-en-fc3864d847e1789a7c6debebcaa4295a.png";